<div [id]="id" class="period-picker">
  <button class="btn period-trigger" type="button" (click)="toggle()">
    <span class="value-text" *ngIf="!summary">{{ label | translate }}</span>
    <span class="value-text" *ngIf="summary">{{ summary }}</span>
    <span class="arrow-box">
      <img src="../../assets/icons/gray-arrow-down.svg" alt="arrow" />
    </span>
  </button>
  <div class="period-menu" *ngIf="opened">
    <div class="year-row">
      <span class="year-value">{{ year }}</span>
      <div class="year-nav">
        <button type="button" class="chevron" (click)="incrementYear()" [attr.aria-label]="'increment year'">
          <svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path d="M5 0L10 6H0z"/></svg>
        </button>
        <button type="button" class="chevron" (click)="decrementYear()" [attr.aria-label]="'decrement year'">
          <svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h10L5 6z"/></svg>
        </button>
      </div>
    </div>
    <div class="month-list">
      <label class="month-item" *ngFor="let m of months">
        <input type="checkbox" [(ngModel)]="m.checked" />
        <span>{{ m.name }}</span>
      </label>
    </div>
    <button type="button" class="btn apply-btn" (click)="onApply()">
      {{ 'COMMON.APPLY' | translate }}
    </button>
  </div>
</div>
